module.exports = __webpack_public_path__ + "img/Nutrition.e2603afa.svg";